<div class="rounded border-2 border-gray-500 p-4 p-lg-5" style="border-style: dashed">
  <div class="row gy-3">
    <div class="mr-md-3 col-sm-auto text-center"><img [src]="'products-in-a-box.svg' | addStaticImagePath" width="146px" /></div>
    <div class="col">
      <h5 [translate]="titleToUse()" [translateParams]="translateValues()" data-test="no-associations-found-warning-title"></h5>
      <p [innerHTML]="noAddressGroupsText() | translate: translateValues() | safeHtml" data-test="no-associations-found-warning-text"></p>
      <p class="mb-0">
        <mwe-button-link
          btnId="mwe-button-product-add"
          dataTest="mwe-button-product-add"
          label="shared.noAddressGroupsError.addProductBtn"
          color="blue"
          (clicked)="navigateToProductSearch()"
        />
      </p>
    </div>
  </div>
</div>
